(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  class MegaMenuComponent extends HTMLElement {
    constructor() {
      super();
      this.dropdownsContainer = this.querySelector('.vitrine-mega-menu__dropdowns');
      this.mobileDrawer = this.querySelector('.vitrine-mega-menu__mobile-drawer');
      this.mobileOverlay = this.querySelector('.vitrine-mega-menu__mobile-overlay');
      this.mobileClose = this.querySelector('.vitrine-mega-menu__mobile-close');
      this.mobileToggles = this.querySelectorAll('.vitrine-mega-menu__mobile-toggle');
      this.activeDropdown = null;
      this.boundMenuItems = new Set();
    }

    connectedCallback() {
      this.init();
      this.setupDropdowns();

      // Use MutationObserver to re-bind if header re-renders
      this.observer = new MutationObserver(() => {
        this.setupDropdowns();
      });

      const headerMenu = document.querySelector('.header-menu, header-menu');
      if (headerMenu) {
        this.observer.observe(headerMenu, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    setupDropdowns() {
      // Find all dropdowns in this component
      const dropdowns = this.querySelectorAll('.vitrine-mega-menu__dropdown');

      dropdowns.forEach(dropdown => {
        const menuTitle = dropdown.dataset.menuTitle;
        if (!menuTitle) return;

        // Find matching menu item in the header by its title text
        const menuItems = document.querySelectorAll('.menu-list__list-item');

        menuItems.forEach(menuItem => {
          const linkTitle = menuItem.querySelector('.menu-list__link-title');
          const titleText = linkTitle ? linkTitle.textContent.trim() : '';

          if (titleText.toLowerCase() === menuTitle.toLowerCase()) {
            // Create unique key for this binding
            const bindingKey = `${menuTitle}-${menuItem.outerHTML.substring(0, 50)}`;

            if (!this.boundMenuItems.has(bindingKey)) {
              this.boundMenuItems.add(bindingKey);
              this.bindMenuItemEvents(menuItem, dropdown, menuTitle);
            }
          }
        });
      });
    }

    bindMenuItemEvents(menuItem, dropdown, menuTitle) {
      const link = menuItem.querySelector('.menu-list__link');
      if (!link) return;

      // Click handler
      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isCurrentlyOpen = this.activeDropdown === dropdown &&
          dropdown.getAttribute('aria-hidden') === 'false';

        // Close any open dropdown
        this.closeAllDropdowns();

        // If it wasn't open, open it
        if (!isCurrentlyOpen) {
          this.openDropdown(dropdown);
        }
      };

      // Remove any existing listeners by cloning
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);

      // Add click listener
      newLink.addEventListener('click', handleClick);
    }

    openDropdown(dropdown) {
      // Show the dropdown container
      this.dropdownsContainer.style.position = 'fixed';
      this.dropdownsContainer.style.top = 'var(--header-height, 80px)';
      this.dropdownsContainer.style.left = '0';
      this.dropdownsContainer.style.right = '0';
      this.dropdownsContainer.style.width = '100vw';
      this.dropdownsContainer.style.height = 'auto';
      this.dropdownsContainer.style.visibility = 'visible';
      this.dropdownsContainer.style.pointerEvents = 'auto';
      this.dropdownsContainer.style.overflow = 'visible';
      this.dropdownsContainer.style.zIndex = '9999';

      // Hide all dropdowns first
      this.querySelectorAll('.vitrine-mega-menu__dropdown').forEach(d => {
        d.style.display = 'none';
      });

      // Show this dropdown
      dropdown.style.display = 'block';
      dropdown.setAttribute('aria-hidden', 'false');
      this.activeDropdown = dropdown;
      document.body.setAttribute('data-mega-menu-open', 'true');
    }

    closeAllDropdowns() {
      this.dropdownsContainer.style.visibility = 'hidden';
      this.dropdownsContainer.style.pointerEvents = 'none';

      this.querySelectorAll('.vitrine-mega-menu__dropdown').forEach(d => {
        d.style.display = 'none';
        d.setAttribute('aria-hidden', 'true');
      });

      this.activeDropdown = null;
      document.body.removeAttribute('data-mega-menu-open');
    }

    init() {
      // Mobile close button
      if (this.mobileClose) {
        this.mobileClose.addEventListener('click', () => this.closeMobileMenu());
      }

      // Mobile overlay click
      if (this.mobileOverlay) {
        this.mobileOverlay.addEventListener('click', () => this.closeMobileMenu());
      }

      // Mobile accordion toggles
      this.mobileToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => this.toggleAccordion(e));
      });

      // Listen for mobile menu trigger
      document.addEventListener('vitrine-mega-menu:open', () => this.openMobileMenu());
      document.addEventListener('vitrine-mega-menu:close', () => this.closeMobileMenu());

      // Escape key to close desktop dropdowns
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllDropdowns();
          this.closeMobileMenu();
        }
      });

      // Click outside to close desktop dropdowns
      document.addEventListener('click', (e) => {
        // Don't close if clicking inside the dropdown
        if (this.dropdownsContainer && this.dropdownsContainer.contains(e.target)) {
          return;
        }
        // Don't close if clicking on a menu item with mega menu (handled by bindMenuItemEvents)
        const clickedMenuItem = e.target.closest('.menu-list__list-item');
        if (clickedMenuItem) {
          const linkTitle = clickedMenuItem.querySelector('.menu-list__link-title');
          if (linkTitle) {
            const dropdowns = this.querySelectorAll('.vitrine-mega-menu__dropdown');
            for (const dropdown of dropdowns) {
              if (dropdown.dataset.menuTitle &&
                  dropdown.dataset.menuTitle.toLowerCase() === linkTitle.textContent.trim().toLowerCase()) {
                return; // Let the menu item handler deal with it
              }
            }
          }
        }
        // Close dropdowns
        this.closeAllDropdowns();
      });
    }

    openMobileMenu() {
      if (this.mobileDrawer) {
        this.mobileDrawer.setAttribute('aria-hidden', 'false');
      }
      if (this.mobileOverlay) {
        this.mobileOverlay.setAttribute('aria-hidden', 'false');
      }
      document.body.style.overflow = 'hidden';
    }

    closeMobileMenu() {
      if (this.mobileDrawer) {
        this.mobileDrawer.setAttribute('aria-hidden', 'true');
      }
      if (this.mobileOverlay) {
        this.mobileOverlay.setAttribute('aria-hidden', 'true');
      }
      document.body.style.overflow = '';
    }

    toggleAccordion(e) {
      const toggle = e.currentTarget;
      const submenu = toggle.nextElementSibling;
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', !isExpanded);
      if (submenu) {
        submenu.setAttribute('aria-hidden', isExpanded);
      }
    }
  }

  if (!customElements.get('mega-menu-component')) {
    customElements.define('mega-menu-component', MegaMenuComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
